import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { SrxApi } from '../../api/SrxApi';

const useAddDrugQuote = () => {
    const { mutate: addDrugQuote, isLoading } = useMutation(
        async (payload) => {
            const response = await SrxApi.post('/drugsearch/addquote', payload);
            return response?.data;
        },
        {
            onSuccess: (data) => {
                const message =
                    data?.message ??
                    data?.data?.message ??
                    'Drug quote saved successfully!';
                toast.success(message);
            },
            onError: (error) => {
                const errorMessage =
                    error?.response?.data?.message ||
                    error?.message ||
                    'Failed to save drug quote';
                toast.error(errorMessage);
            },
        }
    );

    return {
        addDrugQuote,
        isAddDrugQuoteLoading: isLoading,
    };
};

export default useAddDrugQuote;
